class HeaderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.desktopScrollMedia = window.matchMedia('(min-width: 1025px) and (pointer: fine), (min-width: 1025px) and (pointer: none)');
    this.ipadScrollMedia = window.matchMedia('(min-width: 750px) and (pointer: coarse)');
    this.tabletScrollMedia = window.matchMedia('(max-width: 749px), (min-width: 750px) and (max-width: 1024px) and (orientation: portrait) and (pointer: coarse)');
    this.onDesktopScrollMediaChange = () => {
      this.removeAttribute('data-desktop-hidden');
      this.removeAttribute('data-desktop-scrolled');
      this.removeAttribute('data-tablet-hidden');
      this.removeAttribute('data-tablet-scrolled');
      this.lastScrollTop = Math.max(0, document.scrollingElement?.scrollTop ?? 0);
    };
    this.desktopScrollMedia.addEventListener('change', this.onDesktopScrollMediaChange);
    this.tabletScrollMedia.addEventListener('change', this.onDesktopScrollMediaChange);
    this.ipadScrollMedia.addEventListener('change', this.onDesktopScrollMediaChange);
    this.updateCompactScrollState = () => {
      if (document.body.classList.contains('mobile-toolbar-ios-menu-scroll-locked')) return;
      this.toggleAttribute('data-mobile-scrolled', (document.scrollingElement?.scrollTop ?? 0) > 8);
    };
    this.updateCompactScrollState();
    document.addEventListener('scroll', this.updateCompactScrollState, { passive: true });
    this.resizeObserver.observe(this);
    this.stickyMode = this.getAttribute("data-sticky-type");
    this.offscreen = false;

    this.menuDrawerHiddenWidth = null;
    this.intersectionObserver = null;
    this.lastScrollTop = 0;

    this.timeout = null;
    this.animationDelay = 150;
    // this.setHeaderHeight();

    if (this.stickyMode) {
      this.observeStickyPosition(this.stickyMode === "always");

      if (this.stickyMode === "scroll-up" || this.stickyMode === "always") {
        // document.addEventListener("scroll", this.handleWindowScroll.bind(this));
        this.onWindowScroll = theme.utils.rafThrottle(this.handleWindowScroll.bind(this));
        document.addEventListener("scroll", this.onWindowScroll, { passive: true });
      }
    }
  }

  disconnectedCallback() {
    this.desktopScrollMedia?.removeEventListener('change', this.onDesktopScrollMediaChange);
    this.tabletScrollMedia?.removeEventListener('change', this.onDesktopScrollMediaChange);
    this.ipadScrollMedia?.removeEventListener('change', this.onDesktopScrollMediaChange);
    document.removeEventListener('scroll', this.updateCompactScrollState);
    this.resizeObserver.disconnect();
    this.intersectionObserver?.disconnect();
    document.removeEventListener("scroll", this.onWindowScroll);
    clearTimeout(this.timeout);
    document.body.style.setProperty("--header-height", "0px");
  }

  // setHeaderHeight() {
  //   const { height } = this.getBoundingClientRect();
  //   document.body.style.setProperty('--header-height', `${height}px`);

  // }

  resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry) return;
    cancelAnimationFrame(this._resizeRaf);
    this._resizeRaf = requestAnimationFrame(() => {
      const { height } = entry.target.getBoundingClientRect();
      document.body.style.setProperty("--header-height", `${height}px`);
    });
  });

  observeStickyPosition(alwaysSticky = true) {
    if (this.intersectionObserver) return;

    const config = {
      threshold: alwaysSticky ? 1 : 0,
    };

    this.intersectionObserver = new IntersectionObserver(([entry]) => {
      if (!entry) return;

      const { isIntersecting } = entry;

      if (alwaysSticky) {
        this.dataset.stickyState = isIntersecting ? "inactive" : "active";
      } else {
        this.offscreen =
          !isIntersecting || this.dataset.stickyState === "active";
      }
    }, config);

    this.intersectionObserver.observe(this);
  }

  handleWindowScroll() {
    // Tablet touch headers remain visible in either orientation; phones keep their existing behavior.
    if (this.ipadScrollMedia?.matches) {
      if (document.body.classList.contains('mobile-toolbar-ios-menu-scroll-locked')) return;
      const scrollTop = Math.max(0, document.scrollingElement?.scrollTop ?? 0);
      this.toggleAttribute('data-tablet-scrolled', scrollTop > 8);
      this.toggleAttribute('data-desktop-scrolled', scrollTop > 8);
      this.removeAttribute('data-tablet-hidden');
      this.removeAttribute('data-desktop-hidden');
      this.lastScrollTop = scrollTop;
      return;
    }
    if (this.tabletScrollMedia?.matches) {
      if (document.body.classList.contains('mobile-toolbar-ios-menu-scroll-locked')) return;
      const scrollTop = Math.max(0, document.scrollingElement?.scrollTop ?? 0);
      const delta = scrollTop - this.lastScrollTop;
      this.toggleAttribute('data-tablet-scrolled', scrollTop > 8);
      if (scrollTop <= this.offsetHeight || this.contains(document.activeElement)) {
        this.removeAttribute('data-tablet-hidden');
      } else if (Math.abs(delta) >= 8) {
        this.toggleAttribute('data-tablet-hidden', delta > 0);
      } else {
        return;
      }
      this.lastScrollTop = scrollTop;
      return;
    }
    if (this.classList.contains("mast-header--reference") && this.desktopScrollMedia?.matches) {
      const scrollTop = Math.max(0, document.scrollingElement?.scrollTop ?? 0);
      const delta = scrollTop - this.lastScrollTop;
      this.toggleAttribute("data-desktop-scrolled", scrollTop > 0);
      if (scrollTop <= this.offsetHeight || this.contains(document.activeElement)) {
        this.removeAttribute("data-desktop-hidden");
      } else if (Math.abs(delta) >= 6) {
        const hide = delta > 0;
        this.toggleAttribute("data-desktop-hidden", hide);
        if (hide) {
          this.querySelectorAll(".mast-original__disclosure[open]").forEach((details) => {
            details.open = false;
            details.querySelector(":scope > summary")?.setAttribute("aria-expanded", "false");
          });
        }
      } else {
        return;
      }
      this.lastScrollTop = scrollTop;
      return;
    }
    if (!this.offscreen && this.stickyMode !== "always") return;

    const scrollTop = document.scrollingElement?.scrollTop ?? 0;
    const isScrollingUp = scrollTop < this.lastScrollTop;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }

    if (this.stickyMode === "always") {
      const isAtTop = this.getBoundingClientRect().top >= 0;

      if (isAtTop) {
        this.dataset.scrollDirection = "none";
      } else if (isScrollingUp) {
        this.dataset.scrollDirection = "up";
      } else {
        this.dataset.scrollDirection = "down";
      }

      this.lastScrollTop = scrollTop;
      return;
    }

    if (isScrollingUp) {
      this.removeAttribute("data-animating");

      if (this.getBoundingClientRect().top >= 0) {
        // reset sticky state when header is scrolled up to natural position
        this.offscreen = false;
        this.dataset.stickyState = "inactive";
        this.dataset.scrollDirection = "none";
      } else {
        // show sticky header when scrolling up
        this.dataset.stickyState = "active";
        this.dataset.scrollDirection = "up";
      }
    } else if (this.dataset.stickyState === "active") {
      this.dataset.scrollDirection = "none";
      // delay transitioning to idle hidden state for hiding animation
      this.setAttribute("data-animating", "");

      this.timeout = setTimeout(() => {
        this.dataset.stickyState = "idle";
        this.removeAttribute("data-animating");
      }, this.animationDelay);
    } else {
      this.dataset.scrollDirection = "none";
      this.dataset.stickyState = "idle";
    }

    this.lastScrollTop = scrollTop;
  }
}

if (!customElements.get("header-component"))
  customElements.define("header-component", HeaderComponent);

function calculateHeaderGroupHeight(
  header = document.querySelector('#header-component'),
  headerGroup = document.querySelector('#header-group')
) {
  if (!headerGroup) return 0;

  let totalHeight = 0;
  const children = headerGroup.children;

  for (let i = 0; i < children.length; i++) {
    const element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    totalHeight += element.offsetHeight;
  }

  // If the header is transparent and has a sibling section, add the height of the header to the total height
  if (header instanceof HTMLElement && header.hasAttribute('transparent') && !header.parentElement?.nextElementSibling) {
    return totalHeight + header.offsetHeight;
  }

  return totalHeight;
}

function updateHeaderHeights() {
  const header = document.querySelector('header-component');

  // Early exit if no header - nothing to do
  if (!(header instanceof HTMLElement)) return;

  // Calculate initial height(s
  // const headerHeight = header.offsetHeight;
  const headerGroupHeight = calculateHeaderGroupHeight(header);

  // document.body.style.setProperty('--header-height', `${headerHeight}px`);
  document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
}

function setheaderRowHeight() {
  const headerMenu = document.querySelector('.header__row [data-main-menu]');
  if (!headerMenu) return;

  const { height } = headerMenu.closest('.header__row').getBoundingClientRect();
  document.body.style.setProperty('--header-row-menu-height', `${height}px`);
}

if (document.readyState === "complete") {
  setheaderRowHeight();
  updateHeaderHeights();
  setheaderRowHeight();
} else {
  window.addEventListener("load", () => {
    updateHeaderHeights();
    setheaderRowHeight();
  });
}